import { render, staticRenderFns } from "./InputGroupIngredientsParentAccordian.vue?vue&type=template&id=3145675e"
import script from "./InputGroupIngredientsParentAccordian.vue?vue&type=script&lang=js"
export * from "./InputGroupIngredientsParentAccordian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports